import { httpsCallable } from 'firebase/functions';
import { functions } from '../constants/firebaseModular';
import * as Sentry from '@sentry/browser';
import { handleValidateEmailResponse } from '../types/Patient/HandleValidateEmailResponse';
import { HandleValidateEmailPayload } from '../types/Patient/HandleValidateEmailPayload';

export const handleValidateEmail = async (
  payload: HandleValidateEmailPayload,
): Promise<handleValidateEmailResponse> => {
  const postToCloudFunction = httpsCallable(functions, 'validateEmail') as (
    // eslint-disable-next-line
    payload: HandleValidateEmailPayload,
  ) => Promise<handleValidateEmailResponse>;

  return await postToCloudFunction(payload)
    .then(async (response) => {
      if (response.data.status === 'error') {
        if (payload?.email?.length > 5) {
          Sentry.captureMessage(
            `Error validating user email for ${payload.email.toLocaleUpperCase()}:  ${response.data.message}`,
          );
        }
        return { data: { status: 'error' as const, message: response.data.message } };
      } else {
        return { data: { status: 'success' as const, message: response.data.message } };
      }
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      Sentry.captureException(error);
      console.error('Error calling cloud function', errorCode, errorMessage);
      return { data: { status: 'error', message: 'An error occurred while validating email address' } };
    });
};
